<template>
    <div style="overflow: hidden;width: 100%">
        <CommonHeader/>
        <div class="container" style="min-height: calc(100vh - 56px - 88px);">
            <a-row>
                <a-col class="mt-3 mb-3" :span="24">
                    <a-breadcrumb>
                        <a-breadcrumb-item><a href="">首页</a></a-breadcrumb-item>
                        <a-breadcrumb-item>资格审查文件上传</a-breadcrumb-item>
                    </a-breadcrumb>
                </a-col>
            </a-row>
            <page-header-wrapper>
                <a-card>
                    <a-form :form="form" class="custom pick-100 form-input about">
                        <a-row>
                            <a-col :span="24">
                                <a-divider class="color-orange mt-6" orientation="left">项目信息</a-divider>
                            </a-col>
                            <table style="width:100%" class="fx-form">
                                <tr>
                                    <th>项目名称:</th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['xmmc',{initialValue:project.projectName}]"
                                            />
                                        </a-form-item>
                                    </td>
                                    <th>项目编号:</th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['xmbh',{initialValue:project.wbbh?project.wbbh:project.projectCode}]"
                                            />
                                        </a-form-item>
                                    </td>
                                </tr>
                                <tr>
                                    <th>采购人单位:</th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['cgrmc',{initialValue:project.purchaserUnit}]"
                                            />
                                        </a-form-item>
                                    </td>
                                    <th>报名截止时间:</th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    size="large"
                                                    style="color: red;font-weight: bold"
                                                    disabled
                                                    v-model="project.signEnd"></a-input>
                                        </a-form-item>
                                    </td>
                                </tr>
                            </table>
                        </a-row>
                        <a-row>
                            <a-col :span="24">
                                <a-divider class="color-orange mt-6" orientation="left">供应商信息</a-divider>
                            </a-col>
                            <table style="width:100%" class="fx-form">
                                <tr>
                                    <th>供应商名称:</th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['supplierName',{initialValue:supplier.supplierName}]"
                                            />
                                        </a-form-item>
                                    </td>
                                    <th>
                                        <span v-if="supplier.supplierType === '2'">统一社会信用代码:</span>
                                        <span v-else-if="supplier.supplierType === '1' && supplier.natureType === '2'">注册号:</span>
                                        <span v-else-if="supplier.supplierType === '1' && supplier.natureType === '1'">身份证号:</span>
                                    </th>
                                    <td>
                                        <a-form-item>
                                            <a-input
                                                    v-if="supplier.supplierType === '2'"
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['supplierCode',{initialValue:supplier.supplierCode}]"
                                            />
                                            <a-input
                                                    v-if="supplier.supplierType === '1'"
                                                    size="large"
                                                    style="color: black;font-weight: bold"
                                                    disabled
                                                    v-decorator="['supplierCode',{initialValue:supplier.legalIdCard}]"
                                            />
                                        </a-form-item>
                                    </td>
                                </tr>
                            </table>
                        </a-row>
                      <a-row v-if="bidBmys && bidBmys.scjg === '2' ">
                        <a-col :span="24">
                          <a-divider class="color-orange mt-6" orientation="left">前置审查意见</a-divider>
                        </a-col>
                        <table style="width:100%" class="fx-form">
                          <tr>
                            <th colspan="3" style="text-align: left;padding-left: 65px">
                              <a-form-item>
                                您提交的资格审查文件审核不通过，请修改后重新上传。
                              </a-form-item>
                            </th>
                            <td>
                            </td>
                          </tr>
                          <tr>
                            <th>审查意见:</th>
                            <td>
                              <a-form-item>
                                <span style="color: red">{{ bidBmys.sbyy }}</span>
                              </a-form-item>
                            </td>
                          </tr>
                        </table>
                      </a-row>
                        <a-row>
                            <a-col :span="24">
                                <a-divider class="color-orange mt-6" orientation="left">资格审查文件上传</a-divider>
                            </a-col>
                            <table style="width:100%" class="fx-form">
                                <tr>
                                    <th class="not-null">资格审查文件:</th>
                                    <td>
                                        <a-form-item>
                                            <upload-selector file-tips="如果有多个文件请打包成一个文件上传"  :referId="bidBmys.id" :max="1" ref="selectorBmsc"
                                                             :readonly="checkSh" configKey='BID_BMSC_FILE'/>
                                        </a-form-item>
                                    </td>
                                </tr>
                            </table>
                        </a-row>
                        <a-row class="mt-6">
                            <a-col style="text-align: center">
                                <a-button class="mt-4" type="primary" :disabled="checkSh"
                                          @click="onSubmitCheck">{{checkSh?'已提交审核':'提交审核'}}
                                </a-button>
                            </a-col>
                        </a-row>
                    </a-form>
                </a-card>
            </page-header-wrapper>
        </div>
        <CommonFooter/>
    </div>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'
    import {PageView} from '@/layouts'
    import STable from '@/components/Table'
    import moment from 'moment'
    import 'vue-area-linkage/dist/index.css'
    import UploadSelector from "../../components/selector/UploadSelector";
    import CommonHeader from '../common/CommonHeader'
    import CommonFooter from "../common/CommonFooter";
    const uuidv4 = require('uuid/v4')

    export default {
        created() {
            this.loadData()
        },
        components: {
            PageView,
            STable,
            moment,
            UploadSelector,
            CommonFooter,
            CommonHeader
        },
        name: 'ZgYsFile',
        data() {
            return {
                projectId: this.$route.query.projectId,
                bidBmys: {id:uuidv4()},
                form: this.$form.createForm(this),
                supplier: {},
                project: {},
            }
        },
      computed: {
        checkSh(){
          return this.bidBmys && this.bidBmys.scjg && this.bidBmys.scjg !== '2'
        }
      },
        methods: {
            loadData() {
                if (!this.projectId) {
                    this.error("项目ID数据异常!")
                    return;
                }
                let url = '/api/v1/supplier/legalsign/getProjectDetails.json?projectId=' + this.projectId
                this.$http.get(url).then(res => {
                    this.supplier = res.supplier
                    this.projectIdAndsupplierId = this.projectId+res.supplier.id
                    this.account = res.account
                    this.project = res.project
                    this.bidBmys = res.bmsc || this.bidBmys
                    this.project.signEnd=this.project.signEnd?this.project.signEnd.substring(0,this.project.signEnd.length-3):''
                })
            },
            error(val) {
                this.$error({
                    title: '提示',
                    content: val
                })
            },
            onSubmitCheck() {
                let that = this
                if (that.$refs.selectorBmsc.uploadFiles.length === 0) {
                    that.$error({
                        title: '提示',
                        content: '请先上传资格审查文件！！！'
                    })
                    return
                }
                that.$confirm({
                    title: '提交审核',
                    content: '是否确认提交资格审查文件？\n' +
                        '提交后除非审核不通过，否则不允许修改！',
                    onOk() {
                        let url = '/api/v1/supplier/legalsign/addBmsc.json'
                        let data = {...that.bidBmys}
                        data.xmid=that.projectId
                        data.xmbh=that.project.wbbh?that.project.wbbh:that.project.projectCode
                        data.xmmc=that.project.projectName
                        that.$http.post(url,qs.stringify(data)).then(res => {
                          if (res.code !== 200) {
                            if(res.code === 205){
                              that.$error({
                                title: '提示',
                                content: res.msg
                              })
                            }else {
                              that.$message.error('提交失败')
                            }
                            return
                          }
                          that.loadData()
                          that.$message.success('提交审核成功')
                          that.$router.go(-1)
                        })
                    }, onCancel() {
                        console.log("点击了取消")
                    }
                })

            },
        }
    }
</script>

<style lang="less" scoped>
    .step-form-style-desc {
        padding: 0 56px;
        color: rgba(0, 0, 0, .45);

        h3 {
            margin: 0 0 12px;
            color: rgba(0, 0, 0, .45);
            font-size: 16px;
            line-height: 32px;
        }

        h4 {
            margin: 0 0 4px;
            color: rgba(0, 0, 0, .45);
            font-size: 14px;
            line-height: 22px;
        }

        p {
            margin-top: 0;
            margin-bottom: 12px;
            line-height: 22px;
        }
    }

    /deep/ .ant-form-item-label label {
        color: #8c8c8c;
    }

    /deep/ .ant-form-item-children {
        color: #000;
        font-weight: bold;
    }

    .register-title {
        position: relative;
    }

    .register-title img {
        margin: auto;
    }

    .register-title p {
        position: absolute;
        top: 10px;
        font-size: 20px;
        color: #fff;
        width: 100%;
        text-align: center;
    }

    .ant-input {
        width: 100%;
    }

    th {
        width: 125px;
    }

    tr {
        height: 65px;
    }

    .ant-table-thead > tr > th {
        font-weight: bold;
    }
</style>
